// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ft-0";
export var headerCellHover = "_ft-1";
export var readCellContainer = "_ft-2";
export var unreadIndicator = "_ft-3";